import { ReportsPanelComponent } from './reports-panel/reports-panel.component';
import { MainToolsPanelComponent } from './main-tools-panel/main-tools-panel.component';
import { PropertiesPanelComponent } from './properties-panel/properties-panel.component';
import { AtlasSnackbarComponent } from './atlas-snackbar/atlas-snackbar.component';
import { AtlasPanelHeaderComponent } from 'src/app/shared/atlas-panel-header/atlas-panel-header.component';
import { LayerManagementComponent } from './layer-management/layer-management.component';
import { AtlasMenuComponent } from './atlas-menu/atlas-menu.component';
import { LayerLegendComponent } from './layer-legend/layer-legend.component';
import { LayerLegendDetailComponent } from './layer-legend-detail/layer-legend-detail.component';
import { PropertiesLegendComponent } from './properties-panel/legend/properties-legend.component';
import { StatsItemComponent } from './reports-panel/reports-panel-items/stats-item.component';
import { BaseMapLayerCollectionComponent } from './base-map-layer-collection/base-map-layer-collection.component';
import { BaseMapLayerItemComponent } from './base-map-layer-item/base-map-layer-item.component';
import { ScenarioManagementComponent } from './scenario-management/scenario-management.component';
import { AddScenarioComponent } from './scenario-management/add-scenario/add-scenario.component';
import { SwapScenarioComponent } from './scenario-management/swap-scenario/swap-scenario.component';
import { EditScenarioComponent } from './scenario-management/edit-scenario/edit-scenario.component';
import { AddScenarioDialogComponent } from './scenario-management/add-scenario-dialog/add-scenario-dialog.component';
import { AddEditScenarioFormComponent } from './scenario-management/add-edit-scenario-form/add-edit-scenario-form.component';
import { AtlasChipListComponent } from 'src/app/shared/components/atlas-chip-list/atlas-chip-list.component';
import { SwapScenarioDialogComponent } from './scenario-management/swap-scenario-dialog/swap-scenario-dialog.component';
import { SwapScenarioFormComponent } from './scenario-management/swap-scenario-form/swap-scenario-form.component';
import { EditScenarioDialogComponent } from './scenario-management/edit-scenario-dialog/edit-scenario-dialog.component';
import { InfoButtonComponent } from './scenario-management/swap-scenario-form/info-button/info-button.component';
import { InfoBoxComponent } from 'src/app/shared/components/atlas-info-box/atlas-info-box.component';
import { DeleteScenarioConfirmationDialogComponent } from './scenario-management/delete-scenario-confirmation-dialog/delete-scenario-confirmation-dialog.component';
import { DeleteSupplyPointConfirmationDialogComponent } from './scenario-management/delete-supply-point-confirmation-dialog/delete-supply-point-confirmation-dialog.component';
import { DeltaSummaryComponent } from './scenario-management/delta-summary/delta-summary.component';
import { SavePendingSupplyPointConfirmationDialogComponent } from './properties-panel/save-pending-supply-point-confirmation-dialog/save-pending-supply-point-confirmation-dialog.component';
import { SMPropertiesPanelButtonsComponent } from './properties-panel/spatial-modeller-properties/sm-properties-panel-buttons/sm-properties-panel-buttons.component';
import { NavbarComponent } from './navbar/navbar.component';
import { WithNavbarComponent } from './with-navbar/with-navbar.component';
import { LocationPanelComponent } from './properties-panel/location-panel/location-panel.component';
import { ChangeLocationPendingConfirmationDialogComponent } from './properties-panel/change-location-pending-confirmation-dialog/change-location-pending-confirmation-dialog.component';
import { AddEditScenarioValidationDialogComponent } from './scenario-management/add-edit-scenario-validation-dialog/add-edit-scenario-validation-dialog.component';
import { LayerTriggerScaleTextComponent } from './layer-trigger-scale-text/layer-trigger-scale-text.component';
import { LayerDescriptionComponent } from './layer-description/layer-description.component';
import { ManagementMobileViewPanelComponent } from './managment-mobile-view-panel/managment-mobile-view-panel.component';
import { FeatureButtonsComponent } from './feature-buttons/feature-buttons.component';
import { SpatialModellerPropertiesComponent } from './properties-panel/spatial-modeller-properties/spatial-modeller-properties.component';
import { LocatorPropertiesComponent } from './properties-panel/locator-properties/locator-properties.component';
import { LocatorPropertiesPanelButtonsComponent } from './properties-panel/locator-properties/locator-properties-panel-buttons/locator-properties-panel-buttons.component';
import { SpatialModellerReportsComponent } from './reports-panel/spatial-modeller-reports/spatial-modeller-reports.component';
import { SmReportsPanelButtonsComponent } from './reports-panel/spatial-modeller-reports/sm-reports-panel-buttons/sm-reports-panel-buttons.component';
import { LocatorReportsComponent } from './reports-panel/locator-reports/locator-reports.component';
import { CopyrightNoticesComponent } from './copyright-notices/copyright-notices.component';
import { LocatorReportsPanelButtonsComponent } from './reports-panel/locator-reports/locator-reports-panel-buttons/locator-reports-panel-buttons.component';
import { StreetViewJpegComponent } from './street-view-jpeg/street-view-jpeg.component';
import { LibraryManagementComponent } from './library-management/library-management.component';
import { AddLibraryComponent } from './library-management/add-library/add-library.component';
import { EditLibraryComponent } from './library-management/edit-library/edit-library.component';
import { LocatorReportsStatsComponent } from './reports-panel/locator-reports/locator-reports-stats/locator-reports-stats.component';
import { AddLibraryDialogComponent } from './library-management/add-library-dialog/add-library-dialog.component';
import { LocatorReportsGraphComponent } from './reports-panel/locator-reports/locator-reports-graph/locator-reports-graph.component';
import { AddEditLibraryFormComponent } from './library-management/add-edit-library-form/add-edit-library-form.component';
import { EditLibraryDialogComponent } from './library-management/edit-library-dialog/edit-library-dialog.component';
import { ExpandedLoFiReportComponent } from './expanded-lofi-reports/expanded-lofi-reports.component';
import { LocatorReportsPanelComponent } from './reports-panel/locator-reports/locator-reports-panel/locator-reports-panel.component';
import { SpatialModellerReportsPanelComponent } from './reports-panel/spatial-modeller-reports/sm-reports-panel/sm-reports-panel.component';
import { SwapLibraryFormComponent } from './library-management/swap-library-form/swap-library-form.component';
import { SwapLibraryDialogComponent } from './library-management/swap-library-dialog/swap-library-dialog.component';
import { SwapLibraryComponent } from './library-management/swap-library/swap-library.component';
import { DeleteLibraryConfirmationDialogComponent } from './library-management/delete-library-confirmation-dialog/delete-library-confirmation-dialog.component';
import { FeatureManagementComponent } from './feature-management-panel/feature-management-panel.component';
import { LocatorLibraryLocationsListComponent } from './locator-library-locations-list/locator-library-locations-list.component';
import { FeatureManagementButtonsComponent } from './feature-management-buttons/feature-management-buttons.component';
import { CatchmentListComponent } from './properties-panel/locator-properties/catchment-list/catchment-list.component';
import { AtlasIconTextButtonComponent } from 'src/app/shared/components/atlas-icon-text-button/atlas-icon-text-button.component';
import { CatchmentFormComponent } from './properties-panel/locator-properties/catchment-form/catchment-form.component';
import { EditLocationDescriptionComponent } from './properties-panel/locator-properties/edit-location-description/edit-location-description.component';
import { EditLocationDescriptionDialogComponent } from './properties-panel/locator-properties/edit-location-description-dialog/edit-location-description-dialog.component';
import { EditLocationDescriptionFormComponent } from './properties-panel/locator-properties/edit-location-description-form/edit-location-description-form.component';
import { DeleteCatchmentConfirmationDialogComponent } from './properties-panel/locator-properties/catchment-list/delete-catchment-confirmation-dialog/delete-catchment-confirmation-dialog.component';
import { DeleteLocationConfirmationDialogComponent } from './properties-panel/locator-properties/delete-location-confirmation-dialog/delete-location-confirmation-dialog.component';
import { AtlasNumericChipListComponent } from 'src/app/shared/components/atlas-chip-list/atlas-numeric-chip-list.component';
import { AddEditCatchmentDialogComponent } from './properties-panel/locator-properties/add-edit-catchment-dialog/add-edit-catchment-dialog.component';
import { AddEditCatchmentButtonsComponent } from './properties-panel/locator-properties/add-edit-catchment-buttons/add-edit-catchment-buttons.component';
import { AddEditPolygonConfirmationDialogComponent } from './properties-panel/locator-properties/add-edit-polygon-confirmation-dialog/add-edit-polygon-confirmation-dialog.component';
import { AddEditPolygonButtonsComponent } from './properties-panel/locator-properties/add-edit-polygon-buttons/add-edit-polygon-buttons.component';
import { LocatorReportingDialogComponent } from './reports-panel/locator-reports/locator-reporting-dialog/locator-reporting-dialog.component';
import { LocatorReportingFormComponent } from './reports-panel/locator-reports/locator-reporting-form/locator-reporting-form.component';
import { AtlasScenarioNameChipListComponent } from 'src/app/shared/components/atlas-chip-list/atlas-scenario-name-chip-list.component';
import { RetrySupplyPointActionDialogComponent } from './properties-panel/retry-supply-point-action-dialog/retry-supply-point-action-dialog.component';
import { ProfilerPropertiesComponent } from './properties-panel/profiler-properties/profiler-properties.component';
import { ProfilerReportsComponent } from './reports-panel/profiler-reports/profiler-reports.component';
import { ProfilerLibraryManagementComponent } from './profiler-library-management/profiler-library-management.component';
import { AddProfilerLibraryComponent } from './profiler-library-management/add-profiler-library/add-profiler-library.component';
import { AddProfilerLibraryDialogComponent } from './profiler-library-management/add-profiler-library-dialog/add-profiler-library-dialog.component';
import { AddProfilerLibraryFormComponent } from './profiler-library-management/add-profiler-library-form/add-profiler-library-form.component';
import { SwapProfilerLibraryComponent } from './profiler-library-management/swap-profiler-library/swap-profiler-library.component';
import { SwapProfilerLibraryFormComponent } from './profiler-library-management/swap-profiler-library-form/swap-profiler-library-form.component';
import { SwapProfilerLibraryDialogComponent } from './profiler-library-management/swap-profiler-library-dialog/swap-profiler-library-dialog.component';
import { EditProfilerLibraryComponent } from './profiler-library-management/edit-profiler-library/edit-profiler-library.component';
import { EditProfilerLibraryDialogComponent } from './profiler-library-management/edit-profiler-library-dialog/edit-profiler-library-dialog.component';
import { EditProfilerLibraryFormComponent } from './profiler-library-management/edit-profiler-library-form/edit-profiler-library-form.component';
import { DeleteProfilerLibraryConfirmationDialogComponent } from './profiler-library-management/delete-profiler-library-confirmation-dialog/delete-profiler-library-confirmation-dialog.component';
import { ProfilerReportsPanelButtonsComponent } from './reports-panel/profiler-reports/profiler-reports-panel-buttons/profiler-reports-panel-buttons.component';
import { ProfilerReportingDialogComponent } from './reports-panel/profiler-reports/profiler-reporting-dialog/profiler-reporting-dialog.component';
import { ProfilerReportingFormComponent } from './reports-panel/profiler-reports/profiler-reporting-form/profiler-reporting-form.component';
import { ProfilerReportsGraphComponent } from './reports-panel/profiler-reports/profiler-reports-graph/profiler-reports-graph.component';
import { ProfilerReportsStatsComponent } from './reports-panel/profiler-reports/profiler-reports-stats/profiler-reports-stats.component';
import { ProfilerReportsPanelComponent } from './reports-panel/profiler-reports/profiler-reports-panel/profiler-reports-panel.component';
import { ProfilerBaseClassificationSelectionComponent } from './properties-panel/profiler-properties/profile-base-selection/profiler-base-classification-selection.component';
import { ProfilerImportSummaryComponent } from './properties-panel/profiler-properties/profile-details/profiler-import-summary.component';
import { LocatorReferenceLibraryDialogComponent } from './library-management/reference-library-dialog/reference-library-dialog.component';
import { LocatorReferenceLibraryFormComponent } from './library-management/reference-library-form/reference-library-form.component';
import { AtlasLocatorCatchmentChipListComponent } from './chip-list/atlas-locator-catchment-chip-list.component';
import { ProfilerExportButton } from './properties-panel/profiler-properties/profiler-export-button/profiler-export-button.component';
import { SmReportingFormComponent } from './reports-panel/spatial-modeller-reports/sm-reporting-form/sm-reporting-form.component';
import { SmReportingDialogComponent } from './reports-panel/spatial-modeller-reports/sm-reporting-dialog/sm-reporting-dialog.component';
import { SwitchTenantConfirmationDialogComponent } from 'src/app/reporting/components/switch-tenant-confirmation-dialog/switch-tenant-confirmation-dialog-component';
import { LocatorImportLibraryDataComponent } from './library-management/locator-import-library-data/locator-import-library-data.component';
import { LocatorImportLibraryDataDialogComponent } from './library-management/locator-import-library-data-dialog/locator-import-library-data-dialog.component';
import { LocatorImportLibraryDataFormComponent } from './library-management/locator-import-library-data-form/locator-import-library-data-form';
import { LocatorImportLibraryDataFormComponent2 } from './library-management/locator-import-library-data-form-2/locator-import-library-data-form-2.component';
import { LocatorImportLibraryDataFormComponent3 } from './library-management/locator-import-library-data-form-3/locator-import-library-data-form-3.component';
import { StepsDialogErrorsComponent } from './library-management/steps-dialog-errors/steps-dialog-errors.component';
import { MapControlPanelComponent } from 'src/app/shared/atlas-mapping/components/map-control-panel/map-control-panel.component';
import { DataUpdateDialogComponent } from './data-update-dialog/data-update-dialog.component';
import { LocatorLibrarySummaryStatsDialogComponent } from './library-management/locator-library-summary-stats-dialog/locator-library-summary-stats-dialog.component';
import { LocatorLibrarySummaryStatsStep1 } from './library-management/locator-library-summary-stats-step-1/locator-library-summary-stats-step-1.component';
import { SimpleStatsPageComponent } from './reports-panel/reports-panel-items/simple-stats-page/simple-stats-page.component';
import { StandardStatsPageComponent } from './reports-panel/reports-panel-items/standard-stats-page/standard-stats-page.component';
import { MapMeasureControlComponent } from 'src/app/shared/atlas-mapping/components/map-measure-control/map-measure-control.component';
import { ShareMapDialogComponent } from 'src/app/shared/atlas-mapping/components/share-map-dialog/share-map-dialog.component';
import { FeatureUpdateDialogComponent } from './feature-update-dialog/feature-update-dialog.component';
import { LayerGroupComponent } from './layer-group/layer-group.component';
import { LayerMultipleThemesComponent } from './layer-multiple-themes/layer-multiple-themes.component';
import { SmImportScenarioDataComponent } from './scenario-management/sm-import-scenario-data/sm-import-scenario-data.component';
import { SmImportScenarioDataDialogComponent } from './scenario-management/sm-import-scenario-data-dialog/sm-import-scenario-data-dialog.component';
import { SmImportScenarioDataDialogFormComponent } from './scenario-management/sm-import-scenario-data-dialog-form/sm-import-scenario-data-dialog-form.component';
import { SmImportScenarioDataForm2Component } from './scenario-management/sm-import-scenario-data-form-2/sm-import-scenario-data-form-2.component';
import { SmImportScenarioDataForm3Component } from './scenario-management/sm-import-scenario-data-form-3/sm-import-scenario-data-form-3.component';
import { TenantUpdateDialogComponent } from './tenant-update-dialog/tenant-update-dialog.component';
import { TenantUnavailableDialogComponent } from './tenant-unavailable-dialog/tenant-unavailable-dialog.component';
import { AiChatComponent } from './ai-assistant/ai-chat/ai-chat.component';
import { AiAssistantDialogComponent } from './ai-assistant/ai-assistant-dialog/ai-assistant-dialog.component';
import { AiPromptTemplateLibraryComponent } from './ai-assistant/ai-prompt-template-library/ai-prompt-template-library.component';
import { AiPromptArgumentsDialogComponent } from './ai-assistant/ai-prompt-template-library/ai-prompt-arguments-dialog/ai-prompt-arguments-dialog.component';
import { AiPromptArgumentsFormComponent } from './ai-assistant/ai-prompt-template-library/ai-prompt-arguments-form/ai-prompt-arguments-form.component';
import { AiChatHistoryComponent } from './ai-chat-history/ai-chat-history.component';
import { AiChatHistoryListComponent } from './ai-chat-history-list/ai-chat-history-list.component';
import { FloatingOverlayComponent } from './floating-overlay/floating-overlay.component';
import { SummaryStatsGridComponent } from './locator-library-locations-list/summary-stats-grid/summary-stats-grid.component';
import { SummaryStatsLoadingComponent } from './locator-library-locations-list/summary-stats-grid/summary-stats-loading.component';
import { AtlasActionSnackbarComponent } from './atlas-snackbar/atlas-action-snackbar/atlas-action-snackbar';
import { LocatorBatchCatchmentsDialogComponent } from './library-management/locator-batch-catchments-dialog/locator-batch-catchments-dialog.component';
import { LocatorBatchCatchmentsFormComponent1 } from './library-management/locator-batch-catchments-form-1/locator-batch-catchments-form-1.component';
import { LocatorBatchCatchmentsFormComponent2 } from './library-management/locator-batch-catchments-form-2/locator-batch-catchments-form-2.component';
import { LocatorBatchReportsDialogComponent } from './library-management/locator-batch-reports-dialog/locator-batch-reports-dialog.component';
import { LocatorBatchReportsFormComponent1 } from './library-management/locator-batch-reports-form-1/locator-batch-reports-form-1.component';
import { LocatorBatchReportsFormComponent2 } from './library-management/locator-batch-reports-form-2/locator-batch-reports-form-2.component';
import { ScenarioChangePendingConfirmationDialogComponent } from './scenario-management/scenario-change-pending-confirmation-dialog/scenario-change-pending-confirmation-dialog.component';
import { SmCopyScenarioDataDialogComponent } from './scenario-management/sm-copy-scenario-data-dialog/sm-copy-scenario-data-dialog.component';
import { SmCopyScenarioDataFormComponent } from './scenario-management/sm-copy-scenario-data-form/sm-copy-scenario-data-form.component';
import { SmCopyScenarioDataForm2Component } from './scenario-management/sm-copy-scenario-data-form-2/sm-copy-scenario-data-form-2.component';

export const components = [
  PropertiesPanelComponent,
  MainToolsPanelComponent,
  ReportsPanelComponent,
  AtlasSnackbarComponent,
  AtlasPanelHeaderComponent,
  LayerManagementComponent,
  AtlasMenuComponent,
  LayerLegendComponent,
  LayerLegendDetailComponent,
  LayerTriggerScaleTextComponent,
  LayerDescriptionComponent,
  PropertiesLegendComponent,
  StatsItemComponent,
  BaseMapLayerCollectionComponent,
  BaseMapLayerItemComponent,
  ScenarioManagementComponent,
  AddScenarioComponent,
  SwapScenarioComponent,
  EditScenarioComponent,
  AddScenarioDialogComponent,
  AddEditScenarioFormComponent,
  AtlasChipListComponent,
  SwapScenarioDialogComponent,
  SwapScenarioFormComponent,
  EditScenarioDialogComponent,
  SmImportScenarioDataComponent,
  SmImportScenarioDataDialogComponent,
  SmImportScenarioDataDialogFormComponent,
  SmImportScenarioDataForm2Component,
  SmImportScenarioDataForm3Component,
  SmCopyScenarioDataDialogComponent,
  SmCopyScenarioDataFormComponent,
  SmCopyScenarioDataForm2Component,
  InfoButtonComponent,
  InfoBoxComponent,
  DeleteScenarioConfirmationDialogComponent,
  DeleteSupplyPointConfirmationDialogComponent,
  DeltaSummaryComponent,
  SavePendingSupplyPointConfirmationDialogComponent,
  SMPropertiesPanelButtonsComponent,
  NavbarComponent,
  WithNavbarComponent,
  LocationPanelComponent,
  ChangeLocationPendingConfirmationDialogComponent,
  AddEditScenarioValidationDialogComponent,
  ManagementMobileViewPanelComponent,
  FeatureButtonsComponent,
  SpatialModellerPropertiesComponent,
  LocatorPropertiesComponent,
  LocatorPropertiesPanelButtonsComponent,
  SpatialModellerReportsComponent,
  SmReportsPanelButtonsComponent,
  LocatorReportsComponent,
  CopyrightNoticesComponent,
  LocatorReportsPanelButtonsComponent,
  StreetViewJpegComponent,
  LibraryManagementComponent,
  AddLibraryComponent,
  EditLibraryComponent,
  LocatorReportsStatsComponent,
  AddLibraryDialogComponent,
  LocatorReportsGraphComponent,
  AddEditLibraryFormComponent,
  EditLibraryDialogComponent,
  ExpandedLoFiReportComponent,
  LocatorReportsPanelComponent,
  SpatialModellerReportsPanelComponent,
  SwapLibraryFormComponent,
  SwapLibraryDialogComponent,
  SwapLibraryComponent,
  DeleteLibraryConfirmationDialogComponent,
  FeatureManagementComponent,
  LocatorLibraryLocationsListComponent,
  FeatureManagementButtonsComponent,
  CatchmentListComponent,
  AtlasIconTextButtonComponent,
  CatchmentFormComponent,
  EditLocationDescriptionDialogComponent,
  DeleteCatchmentConfirmationDialogComponent,
  DeleteLocationConfirmationDialogComponent,
  EditLocationDescriptionComponent,
  EditLocationDescriptionFormComponent,
  AtlasNumericChipListComponent,
  AtlasScenarioNameChipListComponent,
  AddEditCatchmentDialogComponent,
  AddEditCatchmentButtonsComponent,
  AddEditPolygonConfirmationDialogComponent,
  AddEditPolygonButtonsComponent,
  MapControlPanelComponent,
  LocatorReportingDialogComponent,
  LocatorReferenceLibraryDialogComponent,
  LocatorReportingFormComponent,
  LocatorReferenceLibraryFormComponent,
  RetrySupplyPointActionDialogComponent,
  ProfilerPropertiesComponent,
  ProfilerReportsComponent,
  ProfilerLibraryManagementComponent,
  AddProfilerLibraryComponent,
  AddProfilerLibraryDialogComponent,
  AddProfilerLibraryFormComponent,
  SwapProfilerLibraryComponent,
  SwapProfilerLibraryDialogComponent,
  SwapProfilerLibraryFormComponent,
  EditProfilerLibraryComponent,
  EditProfilerLibraryDialogComponent,
  EditProfilerLibraryFormComponent,
  DeleteProfilerLibraryConfirmationDialogComponent,
  ProfilerReportsPanelButtonsComponent,
  ProfilerReportingDialogComponent,
  ProfilerReportingFormComponent,
  ProfilerReportsGraphComponent,
  ProfilerReportsStatsComponent,
  ProfilerReportsPanelComponent,
  ProfilerBaseClassificationSelectionComponent,
  ProfilerImportSummaryComponent,
  AtlasLocatorCatchmentChipListComponent,
  ProfilerExportButton,
  SmReportingDialogComponent,
  SmReportingFormComponent,
  SwitchTenantConfirmationDialogComponent,
  LocatorImportLibraryDataComponent,
  LocatorImportLibraryDataDialogComponent,
  LocatorImportLibraryDataFormComponent,
  LocatorImportLibraryDataFormComponent2,
  LocatorImportLibraryDataFormComponent3,
  StepsDialogErrorsComponent,
  DataUpdateDialogComponent,
  FeatureUpdateDialogComponent,
  TenantUpdateDialogComponent,
  TenantUnavailableDialogComponent,
  LocatorLibrarySummaryStatsDialogComponent,
  LocatorLibrarySummaryStatsStep1,
  SimpleStatsPageComponent,
  StandardStatsPageComponent,
  MapMeasureControlComponent,
  ShareMapDialogComponent,
  LayerGroupComponent,
  LayerMultipleThemesComponent,
  AiChatComponent,
  AiAssistantDialogComponent,
  AiPromptTemplateLibraryComponent,
  AiPromptArgumentsDialogComponent,
  AiPromptArgumentsFormComponent,
  AiChatHistoryComponent,
  AiChatHistoryListComponent,
  FloatingOverlayComponent,
  SummaryStatsGridComponent,
  SummaryStatsLoadingComponent,
  AtlasActionSnackbarComponent,
  LocatorBatchCatchmentsDialogComponent,
  LocatorBatchCatchmentsFormComponent1,
  LocatorBatchCatchmentsFormComponent2,
  LocatorBatchReportsDialogComponent,
  LocatorBatchReportsFormComponent1,
  LocatorBatchReportsFormComponent2,
  ScenarioChangePendingConfirmationDialogComponent
];
